"use client";

import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { TelegramProvider } from "@/components/telegram-provider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <TelegramProvider>
        {children}
        <Toaster position="top-center" />
      </TelegramProvider>
    </ThemeProvider>
  );
}
